/* eslint-disable camelcase */
export default {
	cert_email_audit: 'Certificate key email submission for approval',
	wait_merchant_no: 'Merchant ID',
	wait_merchant_full_name: 'Group merchant full name',
	email_applicant: 'Key mail recipient (applicant)',
	email_cc: 'Key mail cc',
	dev_doc_tip: 'Development interface guide document (please refer to the certificate key required by the product function before applying)',
	dev_doc_audit_tip: 'Development interface guide document (please check the certificate key required by the product type before approval)',
	apply_content: 'Apply content',
	please_select_apply_content: 'Please select the application content',
	key_version: 'key version',
	apply_version_2: 'Apply for APIV2 key',
	apply_version_3: 'Apply for APIV3 key',
	api_version_2: 'APIV2',
	api_version_3: 'APIV3',
	apply_range: 'Scope of use',
	please_input_apply_range: 'Please enter the scope of use',
	apply_range_tip_1: '*The key applies to the use of the scope, not to use and disseminate the data in any way; if it is violated',
	apply_status: 'Apply status',
	apply_use_range: 'Application scope of certificate key application',
	review_approval: 'Review/Approval',
	review_approval_history: 'Review/Approval history',
	review_approval_comment: 'Review/Approval comments',
	please_input: 'please input',
	current_reviewer: 'Current reviewer',
	current_node: 'Current Node',
	handler: 'Handler',
	result: 'Result',
	step: 'Step',
	opinion: 'Opinion',
	processing_time: 'Processing time',
	time_consuming: 'Time consuming',
	current_merchant: 'current merchant no.',
	current_merchant_full_name: 'Current group merchant full name',
	wait: 'Waiting for ',
	cert_serial_no: 'Certificate serial number',
	cert_pwd: 'Certificate password',
	wait_upload_cert: 'Certificate attachment',
	wait_upload_cert_tip_1: 'apiclient_cert.p12',
	certificate: 'Certificate',
	merchant_cert_apply_number_placeholder:
		'please enter the merchant number. multiple merchant numbers separated by commas can be entered: xxx,yyy ',
	bizSystem: 'Business system name/code',
	bussiness_system: 'Business system',
	bizSystem_tip: 'Unique and unique name or code to identify the business system (4-100 characters) ',
	bizSystem_placeholder: 'e.g. Group Merchant number platform /gmmp',
	bizContactPerson: 'Business contact person',
	bizContactPerson_tip: 'multiple business contacts can be selected',
	bizSystemUrl: 'Business system address',
	bizSystemUrl_placeholder: 'e.g. gmmp-pro.woa.com',
	apply_notice_1: 'Wechat product capability required certificate and key version guide',
	certificate_selection: 'Certificate selection',
	apply_key_versions: 'Apply key versions',
	no_available_merchant: 'There is no qualified merchant number',
	please_make_sure_admin_same: 'Please make sure that the super adminof all merchant  are consistent',
	apply_time: 'Apply time',
	cancel_apply: 'Cancel apply',
	get_cert_key: 'Get decryption key',
	leader_of_applicant: 'Leader of applicant',
	api_pwd_register_status: 'API key registration status',
	api_cert_register_status: 'API certificate registration status',
	guidelines_for_applying_for_a_merchant_api_certificate: 'Guidelines for Applying for a Merchant API Certificate',
	guidelines_for_setting_ap_iv2_keys: 'Guidelines for Setting APIv2 Keys',
	guidelines_for_setting_ap_iv3_keys: 'Guidelines for Setting APIv3 Keys'
};
